import * as STRINGS from '../strings'
export default {

  [STRINGS.SAFEWALK_ACTIVATED_TEXT]: 'You will receive notifications when your timer is about to expire. Alerts will be sent if it expires.',
  [STRINGS.SAFEWALK_ALARM_ACTIVE_BODY_TEXT]: 'Your Safe walk check-in timer has expired. Your organization and/or chosen contacts have been alerted.\nIf you are safe, cancel the active alarm below.',
  [STRINGS.SAFEWALK_ALARM_CANCELLED_BODY_TEXT]: 'Your organization and/or chosen contacts will be notified that your Safe walk alarm has been cancelled. Because they may have already been alerted, you may receive calls or text messages to confirm your safety.',
  [STRINGS.SAFEWALK_ALARM_ENDED_BODY_TEXT]: 'Your organization and/or chosen contacts will be notified that your Safe walk has ended safely.',
  [STRINGS.SAFEWALK_ALARM_WARNING_BODY_TEXT]: 'Alerts will be sent with your location and available contact details if your timer expires',
  [STRINGS.SAFEWALK_BUTTON_ALARM_ACTIVE_TEXT]: 'Safe walk alarm triggered',
  [STRINGS.SAFEWALK_BUTTON_BEGIN_TEXT]: 'Start a Safe walk',
  [STRINGS.SAFEWALK_BUTTON_WALK_ACTIVE_TEXT]: 'Safe walk active for',
  [STRINGS.SAFEWALK_BUTTON_WARNING_TEXT]: 'Safe walk active for',
  [STRINGS.SAFEWALK_CONTACTS_DESCRIPTION]: 'Alerts will be sent with your location and available contact details if your timer expires.',
  [STRINGS.SAFEWALK_CONTACTS_DISCLAIMER]: 'Omnilert will only use your contacts\' SMS number to alert them during your Safe walk.',
  [STRINGS.SAFEWALK_CONTACTS_DISCLAIMER]: 'Omnilert will only use your contacts\' SMS number to alert them during your Safe walk.',
  [STRINGS.SAFEWALK_CONTACTS_FORM_DESCRIPTION]: 'Optional: Enter contacts\' SMS numbers below to add them to your Safe walk notifications.',
  [STRINGS.SAFEWALK_CUSTOM_DURATION_TEXT]: 'Set your own timer duration.',
  [STRINGS.SAFEWALK_INSTALL_BANNER_BODY]: 'For better location accuracy, download the app. If you continue here, keep the browser open and your phone unlocked to share location updates if your Safe walk timer expires.',
  [STRINGS.SAFEWALK_INSTALL_BANNER_HEADER]: 'Improve emergency location accuracy',
  [STRINGS.SAFEWALK_OFF_CAMPUS_CONTACTS_FORM_DESCRIPTION]: 'To continue, enter SMS numbers to notify of your Safe walk. If you trigger an alarm, your location will also be shared.',
  [STRINGS.SAFEWALK_OFF_CAMPUS_INFO_ONE_TEXT]: 'Your organization has enabled you to use Safe walk off campus or outside of operating hours. To start a walk you must Add contacts to notify.',
  [STRINGS.SAFEWALK_OFF_CAMPUS_INFO_TWO_TEXT]: 'To continue, select up to (3) contacts to notify of your Safe walk and location should you trigger an alarm.',
  [STRINGS.SAFEWALK_OFF_CAMPUS_TEXT]: 'Your organization allows you to use Safe walk off campus by adding up to (3) contacts to notify.',
  [STRINGS.SAFEWALK_ON_CAMPUS_QUESTION_TEXT]: 'Are you on campus?',
  [STRINGS.SAFEWALK_ON_CAMPUS_TEXT]: 'Your organization may be notified when you start your walk and if you trigger an alarm.',
  [STRINGS.SAFEWALK_SMS_DESCRIPTION]: 'You will receive an SMS and/or Push Notification when your timer is about to expire.',
  [STRINGS.SAFEWALK_TIMER_EXPIRY_INFO]: 'Alerts will be sent with your location and available contact details if your timer expires.',

  [STRINGS.BUTTON_DOWNLOAD]: 'Download',
  [STRINGS.BUTTON_OPEN_APP]: 'Open app',
  [STRINGS.BUTTON_CANCEL]: 'Cancel',
  [STRINGS.BUTTON_CLOSE]: 'Close',
  [STRINGS.BUTTON_CONTINUE]: 'Continue',
  [STRINGS.BUTTON_DIAL_911_SHORT]: 'Dial 911',
  [STRINGS.BUTTON_DIAL_911]: 'Dial 911 if an emergency',
  [STRINGS.BUTTON_EMERGENCY]: 'Press and hold for help',
  [STRINGS.BUTTON_MESSAGE_LOCATION]: 'Message Location',
  [STRINGS.BUTTON_OK]: 'OK',
  [STRINGS.BUTTON_SAFEWALK_ACTIVATE]: 'Begin Safe walk',
  [STRINGS.BUTTON_SAFEWALK_ADD_CONTACTS]: 'Add contacts to notify',
  [STRINGS.BUTTON_SAFEWALK_CANCEL_ALARM]: 'Cancel Alarm',
  [STRINGS.BUTTON_SAFEWALK_CHECK_IN_TIMER_SET]: 'Check-in set for {{duration}}',
  [STRINGS.BUTTON_SAFEWALK_CHECKIN_TIMER]: 'Set Safe walk check-in timer',
  [STRINGS.BUTTON_SAFEWALK_END_WALK]: 'End ',
  [STRINGS.BUTTON_SAFEWALK_NEW_WALK]: 'Start new Safe walk',
  [STRINGS.BUTTON_SAFEWALK_TRIGGER_ALARM]: 'Alarm',
  [STRINGS.BUTTON_SEND]: 'Send',
  [STRINGS.BUTTON_SUBMIT_SILENT_ALERT]: 'Submit Silent Alert',
  [STRINGS.BUTTON_SUBMIT]: 'Submit',
  [STRINGS.BUTTON_TIP_CATEGORY]: 'No category selected',
  [STRINGS.BUTTON_TIP_LOCATION]: 'Tip Location',

  [STRINGS.COMMON_CONFIRM]: 'Yes',
  [STRINGS.COMMON_DENY]: 'No',

  [STRINGS.EMPTY_STATE_RESOURCES]: 'No resources found.',

  [STRINGS.ERROR_ACCOUNT_SETUP]:
    'There is a problem with your account setup, please contact an Administrator.',
  [STRINGS.ERROR_CONFIG_UNDEFINED]:
    'There is a problem with your setup.  Please contact an administrator to configure your push endpoint.',
  [STRINGS.ERROR_FIREBASE]:
    'There is a problem communicating with our system.  Please try your request again.',
  [STRINGS.ERROR_TITLE]: 'An error occurred',
  [STRINGS.ERROR_VALIDATION_401]:
    'The validation code that you entered is invalid.  Please ensure you have entered it correctly',

  [STRINGS.INDICATOR_NEW_MESSAGES]: 'New messages',
  [STRINGS.INDICATOR_SCROLL]: 'Unread messages',
    
  [STRINGS.LABEL_ACCOUNT]: 'Account',
  [STRINGS.LABEL_TIP_CATEGORY]: 'Select tip category',
  [STRINGS.LABEL_TIP_PRIVATE]: 'Make private',
  [STRINGS.LABEL_TIP_LOCATION]: 'Send current location',
  [STRINGS.LABEL_TIP_PRIVATE]: 'Send tip anonymously',

  [STRINGS.LAUNCH]: 'Launch',
  [STRINGS.LAUNCH_SCENARIO]: 'Launch Scenario',

  [STRINGS.MESSAGE_LOCATION]: 'Message Location',
  [STRINGS.MESSAGE_LOCATION_ERROR_TOAST]:
  'Your organization has requested your location to assist in the current situation. Your response or status will be sent without location unless you re-enable location access.',

  [STRINGS.MODAL_BODY_LOCATION_PERMISSION]:
    'Location permissions are not enabled. Please enable location to help our agents assist you better.  Key features will not be available if you decline.',
  [STRINGS.MODAL_BODY_LOCATION_PERMISSION_DENIED]:
    'Location permissions were denied. Please enable location by going into your device settings.  After enabling location, please try again.',
  [STRINGS.MODAL_BODY_TIP_TITLE]: 'Your tip has been submitted.',
  [STRINGS.MODAL_BODY_TIP_TITLE_ANON]: 'Your tip has been anonymously submitted.',
  [STRINGS.MODAL_BODY_TIP_BODY]:
    'Thank you for your report, we are not able to directly respond to tip reports.',
  [STRINGS.MODAL_BODY_TIP_EMERGENCY]:
    'If this is an emergency, please dial local emergency services.',
  [STRINGS.MODAL_TITLE_LOCATION_PERMISSION]: 'Enable location services',
  [STRINGS.MODAL_TITLE_LOCATION_PERMISSION_DENIED]: 'Location services disabled',
  
  [STRINGS.NO_RESPONSE]: 'No Response',
  [STRINGS.NOT_AUTH_TITLE]: "Sorry, you don't have permission to access this page.",
  [STRINGS.NOT_AUTH_SUBTITLE]: 'Please contact your system administrator if you think you have received this message in error.',
  [STRINGS.NOT_FOUND_TITLE]: "Sorry, this page isn't available",
  [STRINGS.NOT_FOUND_SUBTITLE]: "The link you have may be broken, we're unable to find the resource you're looking for.",

  [STRINGS.PLACEHOLDER_MESSAGE]: 'Type your message',
  [STRINGS.PLACEHOLDER_RESPONSE]: 'Enter reply here',
  [STRINGS.PLACEHOLDER_RESOURCES_FILTER]: 'Filter resources',
  [STRINGS.PLACEHOLDER_TIP]: 'Enter tip here',

  [STRINGS.PRIORITY_HEADER_GUN]: 'Gun Detected',
  [STRINGS.PRIORITY_HEADER_PANIC]: 'Panic Button Alert',
  [STRINGS.PRIORITY_HEADER_TIP]: 'Subscriber Tip Report',
  [STRINGS.PRIORITY_FALSE_POSITIVE]: 'False Positive',
  [STRINGS.PRIORITY_MENU_RESOLVE]: 'Resolve Issue',
  [STRINGS.PRIORITY_BADGE_RESOLVED]: 'Resolved',

  [STRINGS.PUSH_REG_TEXT]: 'The Omnilert Mobile App is designed for mobile use. Please open this registration link from your mobile device.',

  [STRINGS.SCREEN_TITLE_TIP]: 'Submit tip',
  [STRINGS.SCREEN_TITLE_TIP_LOCATION]: 'Tip location',
  [STRINGS.SCREEN_TITLE_TIP_ATTACHMENT]: 'Attachment',
  [STRINGS.SCREEN_TITLE_TIP_CATEGORY]: 'Select tip category',

  [STRINGS.SECTION_TITLE_ACCOUNT]: 'Account',
  [STRINGS.SECTION_TITLE_DISPLAY]: 'Display',

  [STRINGS.TAB_TITLE_MESSAGES]: 'Messages',
  [STRINGS.TAB_TITLE_RESOURCES]: 'Resources',
  [STRINGS.TAB_TITLE_SAFEWALK]: 'Safe walk',
  [STRINGS.TAB_TITLE_TIPS]: 'Tips',

  [STRINGS.TIP_CATEGORY_DEFAULT]: 'No category selected',
  [STRINGS.TIP_LOCATION_ERROR_TOAST]:
    'To share the location of your tip with Your organization, please re-enable location access.',
  [STRINGS.TIP_SCREEN_EMERGENCY_LINE_ONE]: 'If this is a safety emergency,',
  [STRINGS.TIP_SCREEN_EMERGENCY_LINE_TWO]: 'Dial local emergency services',

  [STRINGS.USER]: 'User',
  [STRINGS.USERS]: 'Users',

  [STRINGS.USER_ERROR_DEFAULT]: 'An unknown error occurred.',
  [STRINGS.USER_ERROR_MAX_UPLOADS]: 'Please select a maximum of three (3) files to upload.',
  [STRINGS.USER_ERROR_1001]:
    'Your device was removed from the system.  Please contact an administrator.',
  [STRINGS.USER_ERROR_1002]:
    'Your device was removed from the system.  Please contact an administrator.',
  [STRINGS.USER_ERROR_2001]:
    'There was a problem sending your message to our server.  Please try again later.',
  [STRINGS.USER_ERROR_3001]:
    'There was a problem registering your device to receive push notifications.  Please contact an administrator.',
  [STRINGS.USER_ERROR_3002]:
    'There was a problem registering your device to receive push notifications.  Please contact an administrator.',
  [STRINGS.USER_ERROR_4001]:
    'There was a problem registering your device with the system.  Please contact an administrator.',
  [STRINGS.USER_ERROR_4002]:
    'A validation code is required.  Please enter a validation code and try again.',
  [STRINGS.USER_ERROR_4003]:
    'Your validation code is associated with an account not properly configured.  Please contact an administrator.',
  [STRINGS.USER_ERROR_4004]:
    'Your validation code is not registered in our system.  Please ensure it is entered correctly.',
  [STRINGS.USER_ERROR_4005]:
    "There's a problem with your validation code.  Please contact an administrator.",
  [STRINGS.USER_ERROR_4006]:
    'Your validation code is not the correct length.  Please ensure the code is 10 characters.',
  [STRINGS.USER_ERROR_5001]:
    'There was a problem marking a message as read.  Please try again later.'
}
